import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import { useParams } from 'react-router-dom';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import blogs from '../../api/blogs';

import ErrorAttorney from '../../components/attorneys/ErrorAttorney';
import News1 from '../../components/NewsDetails/News1';
import News2 from '../../components/NewsDetails/News2';
import News3 from '../../components/NewsDetails/News3';
import News4 from '../../components/NewsDetails/News4';
import NewsDetailsTemplate from '../../components/NewsDetails/NewsDetailsTemplate';

const componentMap = {
	News1: News1, // Mapping 'News1' to News1 component
	News2: News2, // Mapping 'News2' to News2 component
	News3: News3, // Mapping 'News2' to News2 component
	News4: News4, // Mapping 'News2' to News2 component
	NewsDetailsTemplate: NewsDetailsTemplate, // Mapping 'News2' to News2 component
	// Add more components here as needed
};

const NewsDetailsFull = () => {
	const { slug } = useParams();

	const NewsDetails = blogs.find(item => item.slug === slug);

	return (
		<>
			<Navbar />
			<PageTitle pageTitle={NewsDetails?.title} pagesub={'Actualité'} />
			{NewsDetails && componentMap[NewsDetails.comp]
				? React.createElement(componentMap[NewsDetails.comp])
				: React.createElement(ErrorNews)}
			<Footer />
			<Scrollbar />
		</>
	);
};
export default NewsDetailsFull;
